export default __webpack_public_path__ + "static/media/Automated White.ef3ea348.svg";